import { WalletType } from "@/providers/wallet";
import GradientBorderRadius from "@/ui/gradient-border-radius";
import { IconComponent } from "@/ui/icon";
import Input from "@/ui/input";

const WalletInput = ({
  address,
  walletType,
}: {
  address: string;
  walletType: WalletType;
}) => {
  return (
    <div className="w-[25rem] group  h-[1.375rem]">
      <Input
        value={address}
        readOnly
        leftSide={
          <GradientBorderRadius
            radius="right"
            gradient={
              address && address !== "" ? "reversed-100" : "input-50-min"
            }
            hover="input-50-left"
            className="h-[1.27rem] w-[1.375rem]"
          >
            <Input.Accordion>
              <IconComponent
                className="w-[0.75rem] h-[0.75rem]"
                name={walletType === WalletType.ETH ? "ethereum" : "solanaLogo"}
              />
            </Input.Accordion>
          </GradientBorderRadius>
        }
      />
    </div>
  );
};

export default WalletInput;
